import { createElement } from 'react';
import { PercentPond } from '@jiaminghi/data-view-react';
const DataVPercentPond = (props) => {
    const { style, ...rest } = props;
    const config = {
        ...rest,
    };
    return createElement(PercentPond, { config: config, style: style });
};
export default DataVPercentPond;
